<template>
	<div>
		<vue-particles color="#FFF" :particleOpacity="0.7" :particlesNumber="60" shapeType="circle" :particleSize="4"
			linesColor="#FFF" :linesWidth="1" :lineLinked="true" :lineOpacity="0.4" :linesDistance="150" :moveSpeed="3"
			:hoverEffect="true" hoverMode="grab" :clickEffect="true" clickMode="push" style="z-index: 10;">
		</vue-particles>

		<!-- 人机校验码 提示框 -->
		<el-dialog title="" :visible.sync="dialogVisible" width="30%" style="z-index: 1500;">
			<div class="flex items-center justify-center">
				<div class="bg-white p-8 rounded-lg  w-96">
					<h1 class="text-2xl font-bold text-center mb-6">
						<!-- 人机校验 -->
						{{ $t('language000280') }}
					</h1>
					<div class="mb-4">
						<div class="bg-gray-200 h-16 flex items-center justify-center mb-2 overflow-hidden">
							<img :src="captchaImageUrl" alt="验证码" class="w-full h-full object-cover" />
						</div>
						<div class="flex justify-between items-center">
							<p class="text-sm text-gray-600">
								<!-- 看不清？点击图片刷新 -->
								{{ $t('language000281') }}
							</p>
							<button @click="refreshCaptcha" class="text-blue-500 hover:text-blue-700">
								<i class="fas fa-sync-alt"></i>
								<!-- 刷新 -->
								{{ $t('language000282') }}
							</button>
						</div>
					</div>
					<div class="mb-4">
						<label for="captcha" class="block text-sm font-medium text-gray-700 mb-1">
							<!-- 请输入验证码 -->
							{{ $t('language000283') }}
						</label>
						<div class="relative">
							<input type="text" id="captcha" v-model="captchaInput"
								class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 !rounded-button"
								:placeholder="$t('language000284')" />
							<span class="absolute inset-y-0 right-0 flex items-center pr-3">
								<i class="fas fa-shield-alt text-gray-400"></i>
							</span>
						</div>
					</div>
					<button @click="submitCaptcha"
						class="w-full bg-red-600 text-white py-2 px-4 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition duration-150 ease-in-out !rounded-button whitespace-nowrap">
						<!-- 验证 -->
						{{ $t('language000285') }}
					</button>
				</div>
			</div>
		</el-dialog>

		<div class="min-h-screen bg-gray-50 flex flex-col items-center justify-center py-12 px-4 sm:px-6 lg:px-8">

			<img src="../../assets/login_bg01.jpg"
				style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 0; object-fit: cover;" />

			<link href="https://cdn.jsdelivr.net/npm/tailwindcss@2.2.19/dist/tailwind.min.css" rel="stylesheet">


			<div class="max-w-md w-full space-y-8 bg-white p-6 rounded-lg shadow-lg" style="z-index: 1000;">

				<!-- 数据加载提示框 -->
				<van-overlay :show="loadingData" @click="show = false" style="z-index: 2000;">
					<div style="display: flex;align-items: center;justify-content: center; height: 100%;" @click.stop>
						<van-loading size="24px" vertical>{{ $t('language000053') }}</van-loading>
					</div>
				</van-overlay>

				<!-- 头部Logo和标题 -->
				<div class="flex items-center justify-between" style="margin: 0px; margin-top: -5px;">
					<img src="../../assets/login_bg02.jpg" style="width: 90px; height: 90px;" />
					<h2 class="text-2xl font-semibold text-gray-900">{{ $t('language000098') }}</h2>
				</div>

				<!-- 注册表单 -->
				<form class="mt-8 space-y-6" style="margin-top: 10px;">
					<!-- 手机/邮箱切换 -->
					<div class="flex items-center space-x-4 mb-4">
						<button
							:class="{ 'text-red-500 border-b-2 border-red-600': loginType === 'phone', 'text-gray-500': loginType !== 'phone' }"
							class="pb-2 !rounded-button" @click="loginType = 'phone'">
							{{ $t('language000099') }}
						</button>
						<button
							:class="{ 'text-red-500 border-b-2 border-red-600': loginType === 'email', 'text-gray-500': loginType !== 'email' }"
							class="pb-2 !rounded-button" @click="loginType = 'email'">
							{{ $t('language000100') }}
						</button>
					</div>

					<!-- 手机号/邮箱输入 -->
					<div class="relative">
						<div class="flex items-center">
							<!-- 国家区号选择，仅在手机号输入时显示 -->
							<template v-if="loginType === 'phone'">
								<select v-model="countryCode"
									class="border border-gray-300 rounded-lg px-4 py-2 focus:ring-red-500 focus:border-red-500 mr-2.5"
									style="max-width: 100px; margin:0px 10px 0px 0px; padding:8px 10px;">
									<option value="86">+86 China</option>
									<option value="852">+852 Hong Kong -China</option>
									<option value="853">+853 Macau -China</option>
									<option value="886">+886 Taiwan -China</option>
									<option value="1">+1 United States</option>
									<option value="93">+93 Afghanistan</option>
									<option value="355">+355 Albania</option>
									<option value="213">+213 Algeria</option>
									<option value="1684">+1684 American Samoa</option>
									<option value="376">+376 Andorra</option>
									<option value="244">+244 Angola</option>
									<option value="1264">+1264 Anguilla</option>
									<option value="1268">+1268 Antigua and Barbuda</option>
									<option value="54">+54 Argentina</option>
									<option value="374">+374 Armenia</option>
									<option value="297">+297 Aruba</option>
									<option value="61">+61 Australia</option>
									<option value="43">+43 Austria</option>
									<option value="994">+994 Azerbaijan</option>
									<option value="1242">+1242 Bahamas</option>
									<option value="973">+973 Bahrain</option>
									<option value="880">+880 Bangladesh</option>
									<option value="1246">+1246 Barbados</option>
									<option value="375">+375 Belarus</option>
									<option value="32">+32 Belgium</option>
									<option value="501">+501 Belize</option>
									<option value="229">+229 Benin</option>
									<option value="1441">+1441 Bermuda</option>
									<option value="975">+975 Bhutan</option>
									<option value="591">+591 Bolivia</option>
									<option value="387">+387 Bosnia and Herzegovina</option>
									<option value="267">+267 Botswana</option>
									<option value="55">+55 Brazil</option>
									<option value="673">+673 Brunei</option>
									<option value="359">+359 Bulgaria</option>
									<option value="226">+226 Burkina Fas</option>
									<option value="257">+257 Burundi</option>
									<option value="855">+855 Cambodia</option>
									<option value="237">+237 Cameroon</option>
									<option value="1">+1 Canada</option>
									<option value="238">+238 Cape Verde</option>
									<option value="1345">+1345 Cayman Islands</option>
									<option value="236">+236 Central African Republic</option>
									<option value="235">+235 Chad</option>
									<option value="56">+56 Chile</option>
									<option value="57">+57 Colombia</option>
									<option value="269">+269 Comoros</option>
									<option value="682">+682 Cook Islands</option>
									<option value="506">+506 Costa Rica</option>
									<option value="385">+385 Croatia</option>
									<option value="53">+53 Cuba</option>
									<option value="599">+599 Curacao</option>
									<option value="357">+357 Cyprus</option>
									<option value="420">+420 Czech</option>
									<option value="243">+243 Democratic Republic of the Congo</option>
									<option value="45">+45 Denmark</option>
									<option value="253">+253 Djibouti</option>
									<option value="1767">+1767 Dominica</option>
									<option value="1809">+1809 Dominican Republic</option>
									<option value="593">+593 Ecuador</option>
									<option value="20">+20 Egypt</option>
									<option value="503">+503 El Salvador</option>
									<option value="240">+240 Equatorial Guinea</option>
									<option value="291">+291 Eritrea</option>
									<option value="372">+372 Estonia</option>
									<option value="251">+251 Ethiopia</option>
									<option value="298">+298 Faroe Islands</option>
									<option value="679">+679 Fiji</option>
									<option value="358">+358 Finland</option>
									<option value="33">+33 France</option>
									<option value="594">+594 French Guiana</option>
									<option value="689">+689 French Polynesia</option>
									<option value="241">+241 Gabon</option>
									<option value="220">+220 Gambia</option>
									<option value="995">+995 Georgia</option>
									<option value="49">+49 Germany</option>
									<option value="233">+233 Ghana</option>
									<option value="350">+350 Gibraltar</option>
									<option value="30">+30 Greece</option>
									<option value="299">+299 Greenland</option>
									<option value="1473">+1473 Grenada</option>
									<option value="590">+590 Guadeloupe</option>
									<option value="1671">+1671 Guam</option>
									<option value="502">+502 Guatemala</option>
									<option value="224">+224 Guinea</option>
									<option value="245">+245 Guinea-Bissau</option>
									<option value="592">+592 Guyana</option>
									<option value="509">+509 Haiti</option>
									<option value="504">+504 Honduras</option>
									<option value="36">+36 Hungary</option>
									<option value="354">+354 Iceland</option>
									<option value="91">+91 India</option>
									<option value="62">+62 Indonesia</option>
									<option value="98">+98 Iran</option>
									<option value="964">+964 Iraq</option>
									<option value="353">+353 Ireland</option>
									<option value="972">+972 Israel</option>
									<option value="39">+39 Italy</option>
									<option value="225">+225 Ivory Coast</option>
									<option value="1876">+1876 Jamaica</option>
									<option value="81">+81 Japan</option>
									<option value="962">+962 Jordan</option>
									<option value="7">+7 Kazakhstan</option>
									<option value="254">+254 Kenya</option>
									<option value="686">+686 Kiribati</option>
									<option value="965">+965 Kuwait</option>
									<option value="996">+996 Kyrgyzstan</option>
									<option value="856">+856 Laos</option>
									<option value="371">+371 Latvia</option>
									<option value="961">+961 Lebanon</option>
									<option value="266">+266 Lesotho</option>
									<option value="231">+231 Liberia</option>
									<option value="218">+218 Libya</option>
									<option value="423">+423 Liechtenstein</option>
									<option value="370">+370 Lithuania</option>
									<option value="352">+352 Luxembourg</option>
									<option value="389">+389 Macedonia</option>
									<option value="261">+261 Madagascar</option>
									<option value="265">+265 Malawi</option>
									<option value="60">+60 Malaysia</option>
									<option value="960">+960 Maldives</option>
									<option value="223">+223 Mali</option>
									<option value="356">+356 Malta</option>
									<option value="596">+596 Martinique</option>
									<option value="222">+222 Mauritania</option>
									<option value="230">+230 Mauritius</option>
									<option value="262">+262 Mayotte</option>
									<option value="52">+52 Mexico</option>
									<option value="373">+373 Moldova</option>
									<option value="377">+377 Monaco</option>
									<option value="976">+976 Mongolia</option>
									<option value="382">+382 Montenegro</option>
									<option value="1664">+1664 Montserrat</option>
									<option value="212">+212 Morocco</option>
									<option value="258">+258 Mozambique</option>
									<option value="95">+95 Myanmar</option>
									<option value="264">+264 Namibia</option>
									<option value="977">+977 Nepal</option>
									<option value="31">+31 Netherlands</option>
									<option value="687">+687 New Caledonia</option>
									<option value="64">+64 New Zealand</option>
									<option value="505">+505 Nicaragua</option>
									<option value="227">+227 Niger</option>
									<option value="234">+234 Nigeria</option>
									<option value="47">+47 Norway</option>
									<option value="968">+968 Oman</option>
									<option value="92">+92 Pakistan</option>
									<option value="680">+680 Palau</option>
									<option value="970">+970 Palestine</option>
									<option value="507">+507 Panama</option>
									<option value="675">+675 Papua New Guinea</option>
									<option value="595">+595 Paraguay</option>
									<option value="51">+51 Peru</option>
									<option value="63">+63 Philippines</option>
									<option value="48">+48 Poland</option>
									<option value="351">+351 Portugal</option>
									<option value="1787">+1787 Puerto Rico</option>
									<option value="974">+974 Qatar</option>
									<option value="242">+242 Republic Of The Congo</option>
									<option value="262">+262 Réunion Island</option>
									<option value="40">+40 Romania</option>
									<option value="7">+7 Russia</option>
									<option value="250">+250 Rwanda</option>
									<option value="1869">+1869 Saint Kitts and Nevis</option>
									<option value="1758">+1758 Saint Lucia</option>
									<option value="508">+508 Saint Pierre and Miquelon</option>
									<option value="1784">+1784 Saint Vincent and The Grenadines</option>
									<option value="685">+685 Samoa</option>
									<option value="378">+378 San Marino</option>
									<option value="239">+239 Sao Tome and Principe</option>
									<option value="966">+966 Saudi Arabia</option>
									<option value="221">+221 Senegal</option>
									<option value="381">+381 Serbia</option>
									<option value="248">+248 Seychelles</option>
									<option value="232">+232 Sierra Leone</option>
									<option value="65">+65 Singapore</option>
									<option value="1721">+1721 Saint Maarten (Dutch Part)</option>
									<option value="421">+421 Slovakia</option>
									<option value="386">+386 Slovenia</option>
									<option value="677">+677 Solomon Islands</option>
									<option value="252">+252 Somalia</option>
									<option value="27">+27 South Africa</option>
									<option value="82">+82 South Korea</option>
									<option value="34">+34 Spain</option>
									<option value="94">+94 Sri Lanka</option>
									<option value="249">+249 Sudan</option>
									<option value="597">+597 Suriname</option>
									<option value="268">+268 Swaziland</option>
									<option value="46">+46 Sweden</option>
									<option value="41">+41 Switzerland</option>
									<option value="963">+963 Syria</option>
									<option value="992">+992 Tajikistan</option>
									<option value="255">+255 Tanzania</option>
									<option value="66">+66 Thailand</option>
									<option value="670">+670 Timor-Leste</option>
									<option value="228">+228 Togo</option>
									<option value="676">+676 Tonga</option>
									<option value="1868">+1868 Trinidad and Tobago</option>
									<option value="216">+216 Tunisia</option>
									<option value="90">+90 Turkey</option>
									<option value="993">+993 Turkmenistan</option>
									<option value="1649">+1649 Turks and Caicos Islands</option>
									<option value="256">+256 Uganda</option>
									<option value="380">+380 Ukraine</option>
									<option value="971">+971 United Arab Emirates</option>
									<option value="44">+44 United Kingdoms</option>
									<option value="598">+598 Uruguay</option>
									<option value="998">+998 Uzbekistan</option>
									<option value="678">+678 Vanuatu</option>
									<option value="58">+58 Venezuela</option>
									<option value="84">+84 Vietnam</option>
									<option value="1340">+1340 Virgin Islands, British</option>
									<option value="1284">+1284 Virgin Islands, US</option>
									<option value="967">+967 Yemen</option>
									<option value="260">+260 Zambia</option>
									<option value="263">+263 Zimbabwe</option>

									<!-- 添加更多国家区号 -->
								</select>
							</template>
							<input :type="loginType === 'phone' ? 'tel' : 'email'"
								:placeholder="loginType === 'phone' ? $t('language000006') : $t('language000097')"
								v-model="contactInfo"
								class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-red-500 focus:border-red-500"
								required />
						</div>
					</div>


					<!-- 验证码 -->
					<div class="flex space-x-4">
						<input type="text" :placeholder="$t('language000008')" v-model="verificationCode"
							class="flex-1 px-4 py-2 border border-gray-300 rounded-lg focus:ring-red-500 focus:border-red-500"
							required />
						<button type="button"
							class="px-4 py-2 bg-red-600 text-white rounded-lg !rounded-button hover:bg-red-700 disabled:bg-gray-400"
							:disabled="countDown > 0" @click="sendVerificationCode">
							{{ countDown > 0 ? `${countDown} ${$t('language000104')}` : $t('language000105') }}
						</button>
					</div>

					<!-- 开发者昵称 -->
					<div>
						<input type="text" :placeholder="$t('language000106')" v-model="nickname"
							class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-red-500 focus:border-red-500"
							required />
					</div>

					<!-- 头像上传 -->
					<div class="flex items-center space-x-4">
						<div class="relative w-20 h-20">
							<img :src="avatarUrl || defaultAvatarUrl" class="w-full h-full rounded-full object-cover"
								alt="头像" />
							<input type="file" accept="image/*"
								class="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
								@change="handleAvatarChange" />
						</div>
						<div class="text-sm text-gray-500">{{ $t('language000107') }}</div>
					</div>

					<!-- 密码输入 -->
					<div class="relative">
						<input :type="showPassword ? 'text' : 'password'" :placeholder="$t('language000108')"
							v-model="password"
							class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-red-500 focus:border-red-500"
							required />
						<button type="button"
							class="absolute right-3 top-1/2 transform -translate-y-1/2 !rounded-button"
							@click="showPassword = !showPassword">
							<i :class="showPassword ? 'fa-eye-slash' : 'fa-eye'" class="fas"></i>
						</button>
					</div>

					<!-- 确认密码 -->
					<div class="relative">
						<input :type="showConfirmPassword ? 'text' : 'password'" :placeholder="$t('language000109')"
							v-model="confirmPassword"
							class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-red-500 focus:border-red-500"
							required />
						<button type="button"
							class="absolute right-3 top-1/2 transform -translate-y-1/2 !rounded-button"
							@click="showConfirmPassword = !showConfirmPassword">
							<i :class="showConfirmPassword ? 'fa-eye-slash' : 'fa-eye'" class="fas"></i>
						</button>
					</div>

					<div class="text-sm text-gray-500" style="display: flex; justify-content: center;">
						包含大小写字母和数字的8-16位密码</div>

					<!-- 注册按钮 -->
					<div>
						<button type="submit" @click="register"
							class="w-full py-2 px-4 bg-red-600 hover:bg-red-700 text-white rounded-lg !rounded-button transition duration-200">
							{{ $t('language000049') }}
						</button>
					</div>

					<!-- 登录链接 -->
					<div class="text-center" style="margin-top: 10px;">
						<button class="text-red-500 hover:text-red-800"
							@click="toLogin">{{ $t('language000110') }}</button>
					</div>
				</form>

				<!-- 底部协议 -->
				<div class="text-center text-sm text-gray-500 mt-4">
					{{ $t('language000111') }}
					<button class="text-red-500 hover:text-red-800"
						@click.preven="toDeveloperAgreement">{{ $t('language000112') }}</button>
				</div>

			</div>
		</div>

	</div>

</template>

<script>
	import Cookies from 'js-cookie';
	import axios from 'axios';

	// 引入公用方法
	import {
		getError
	} from '../../../src/utils/StringUtil.js';

	export default {
		mounted() {
			// 在生命周期钩子中获取路由参数

			const userLanguage = navigator.language || navigator.userLanguage; // 获取用户浏览器所配置的语言偏好
			const isLanguageSupported = this.$p_languages.includes(userLanguage); // 检查用户语言是否在支持的语言列表中
			this.$i18n.locale = isLanguageSupported ? userLanguage : this.$p_defaultLanguage; // 如果语言受支持，则设置为用户语言，否则设置为默认语言
			//this.$i18n.locale = 'en'; // 设置为英语
		},
		data() {
			return {
				loadingData: false, // 是否显示加载效果 (加载数据)
				dialogVisible: false, //人机校验码提示框
				uuid: '', //图片的ID
				captchaImageUrl: '', //图形验证码图片
				captchaInput: '', //图形验证码
				loginType: 'phone',
				contactInfo: '', //手机号+邮箱
				countryCode: '', // 默认选择中国区号
				verificationCode: '', //验证码
				nickname: '', //昵称
				password: '', //密码
				confirmPassword: '',
				showPassword: false,
				showConfirmPassword: false,
				countDown: 0,
				defaultAvatarUrl: 'https://ai-public.mastergo.com/ai/img_res/4b067d6a18deda79774887c1b3af3e9c.jpg', //默认的灰色背景头像 有vpn的情况下显示不了
				avatarUrl: '',
				avatarUrlHttp: '', //上传到OSS的图片地址
			};
		},
		methods: {
			sendVerificationCode() { //获取验证码
				if (this.loginType == "phone") { //手机号注册
					if (this.countryCode.length <= 0) {
						this.$message.error(this.$t('language000117')); //请选择区号
						return
					}
					if (this.contactInfo.length <= 0) {
						this.$message.error(this.$t('language000006')); //请输入手机号码
						return
					}
				} else if (this.loginType == "email") { //邮箱注册
					if (this.contactInfo.length <= 0) {
						this.$message.error(this.$t('language000097')); //请输入邮箱
						return
					}
				} else {
					alert('类型错误');
				}

				this.refreshCaptcha();

				//this.dialogVisible = true;
				//发送验证码
				/* */

			},
			refreshCaptcha() { //刷新 获取验证码
				this.loadingData = true;
				axios.get(this.$p_url_Developers + '/captchaImage')
					.then(response => {
						this.loadingData = false;
						console.log("返回的值：", response.data)
						const code = response.data.code; // 获取状态
						if (code === 200) { // 检查状态
							this.uuid = response.data.uuid //图片验证码ID
							this.captchaImageUrl = response.data.img; //图片验证码

							//加载图形验证码
							const img = new Image(); // 创建新的Image对象
							img.onload = () => { // 当图像加载完成时，将Base64字符串赋值给显示图像的变量
								this.captchaImageUrl = img.src;
								this.dialogVisible = true; //显示提示框
							};
							img.onerror = (error) => { // 当图像加载失败时，显示错误信息
								console.error('加载图像失败：', error);
							};
							// 将Base64字符串赋值给图像的src属性
							img.src = `data:image/png;base64,${this.captchaImageUrl}`;

						} else { // 处理状态为失败的情况
							alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
						}
					})
					.catch(error => { // 请求失败时处理错误
						alert("请求失败：" + error);
					});
				this.captchaInput = '';
			},
			submitCaptcha() { //提交验证码

				if (this.captchaInput) {
					if (this.loginType == "phone") { //发送手机验证码
						this.loadingData = true;
						axios.post(this.$p_url_Developers + '/sms/sendSmsCode', {
								imgCode: this.captchaInput, //图形验证码不能为空
								imgUuid: this.uuid, //图形验证码UUID不能为空
								phone: this.contactInfo, //手机号码
								restType: 1, //1:注册，2登录，3找回密码
								type: 0, //0：注册国内短信、1：注册国际短信、2:登录国内验证码、3、登录国际短信、4、注销国内短信、5、注销国际短信
								zone: this.countryCode //国家区号
							})
							.then(response => {
								this.loadingData = false;
								console.log("返回的值：", response.data)
								if (response.data.code === 200) { // 检查状态
									this.$message({ //提示成功
										message: this.$t('language000064'),
										type: 'success'
									});
									this.dialogVisible = false; //隐藏提示框

									this.countDown = 60;
									const timer = setInterval(() => {
										if (this.countDown > 0) {
											this.countDown--;
										} else {
											clearInterval(timer);
										}
									}, 1000);

								} else {
									alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
								}
							})
							.catch(error => {
								alert("请求失败：" + error);
							});
					}

					if (this.loginType == "email") { //发送邮箱验证码
						this.loadingData = true;
						axios.post(this.$p_url_Developers + '/sms/sendEmailCode', {
								imgCode: this.captchaInput, //图形验证码不能为空
								imgUuid: this.uuid, //图形验证码UUID不能为空
								emailAddress: this.contactInfo, //邮箱地址
								restType: 1, //1:注册，2登录，3找回密码
							})
							.then(response => {
								this.loadingData = false;
								console.log("返回的值：", response.data)
								if (response.data.code === 200) { // 检查状态
									this.$message({ //提示成功
										message: this.$t('language000064'),
										type: 'success'
									});
									this.dialogVisible = false; //隐藏提示框

									this.countDown = 60;
									const timer = setInterval(() => {
										if (this.countDown > 0) {
											this.countDown--;
										} else {
											clearInterval(timer);
										}
									}, 1000);

								} else {
									alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
								}
							})
							.catch(error => {
								alert("请求失败：" + error);
							});
					}


				} else {
					this.$message.error(this.$t('language000008')); //请输入验证码
				}
			},
			handleAvatarChange(event) { //上传图片

				console.log("上传图片", event);

				const target = event.target;
				if (target.files && target.files[0]) {
					const file = target.files[0]; // 获取上传的文件
					const reader = new FileReader();
					reader.onload = (e) => {
						this.avatarUrl = e.target.result; // 显示预览
					};
					reader.readAsDataURL(target.files[0]);

					const formData = new FormData(); // 创建一个 FormData 对象
					formData.append("file", file); // 将文件添加到 FormData 对象中
					this.loadingData = true;
					axios.post(this.$p_url_Developers + '/platform/info/sysImageUpload',
							formData, { //上传图片
								withCredentials: true,
								headers: {
									'Content-Type': 'multipart/form-data', //设置为上传文件的类型
								},
							})
						.then(response => {
							this.loadingData = false;
							console.log("上传图片的返回：", response.data)
							const state = response.data.code; // 获取状态
							if (state === 200) { // 检查状态
								this.avatarUrlHttp = response.data.data.url; //图片地址
								console.log("图片地址：", this.$p_urlImage + this.avatarUrlHttp)
							} else {
								alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
							}
						})
						.catch(error => { // 请求失败时处理错误
							alert('请求失败:' + error);
							console.error('Error fetching data:', error);
						});
				}
			},
			register(event) { // 注册
				event.preventDefault(); // 阻止表单提交

				if (this.verificationCode.length <= 0) {
					this.$message.error(this.$t('language000008')); // 请输入验证码
					return;
				}
				if (this.nickname.length <= 2) {
					this.$message.error(this.$t('language000113')); // 名称不可以少于两位
					return;
				}
				if (this.avatarUrl.length <= 2) {
					this.$message.error(this.$t('language000114')); // 请上传头像
					return;
				}
				if (this.password.length < 6) {
					this.$message.error(this.$t('language000115')); // 密码长度不可以小于6位
					return;
				}
				if (this.password !== this.confirmPassword) {
					this.$message.error(this.$t('language000116')); // 两次输入的密码不一致
					return;
				}

				this.loadingData = true; // 开始加载

				if (this.loginType == "phone") { // 手机号注册
					if (this.countryCode.length <= 0) {
						this.$message.error(this.$t('language000117')); // 请选择区号
						this.loadingData = false; // 结束加载
						return;
					}
					if (this.contactInfo.length <= 0) {
						this.$message.error(this.$t('language000006')); // 请输入手机号码
						this.loadingData = false; // 结束加载
						return;
					}

					axios.post(this.$p_url_Developers + '/platform/info/register', {
							avatar: this.$p_urlImage + this.avatarUrlHttp, // 头像
							phoneNum: this.contactInfo, // 手机号码
							zone: this.countryCode, // 国家区号
							password: this.password, // 密码
							nickName: this.nickname, // 昵称
							registerType: 1, // 注册类型 1 手机号 2 邮箱
							smsCode: this.verificationCode, // 验证码
						})
						.then(response => {
							this.loadingData = false; // 结束加载
							console.log("返回的值：", response.data);
							if (response.data.code === 200) { // 检查状态
								this.toLogin();
								this.$notify({ //提示成功
									title: '',
									message: this.$t('language000064'),
									type: 'success'
								});
							} else {
								alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
							}
						})
						.catch(error => {
							this.loadingData = false; // 结束加载
							console.error("请求失败：", error);
							alert("请求失败：" + error);
						});

				} else if (this.loginType == "email") { // 邮箱注册
					if (this.contactInfo.length <= 0) {
						this.$message.error(this.$t('language000097')); // 请输入邮箱
						this.loadingData = false; // 结束加载
						return;
					}

					axios.post(this.$p_url_Developers + '/platform/info/register', {
							avatar: this.$p_urlImage + this.avatarUrlHttp, // 头像
							emailAddress: this.contactInfo, // 邮箱地址
							password: this.password, // 密码
							nickName: this.nickname, // 昵称
							registerType: 2, // 注册类型 1 手机号 2 邮箱
							smsCode: this.verificationCode, // 验证码
						})
						.then(response => {
							this.loadingData = false; // 结束加载
							console.log("返回的值：", response.data);
							if (response.data.code === 200) { // 检查状态
								this.toLogin();
								this.$notify({ //提示成功
									title: '',
									message: this.$t('language000064'),
									type: 'success'
								});
							} else {
								alert("接口失败：" + getError(response.data.code, this.$i18n.locale));
							}
						})
						.catch(error => {
							this.loadingData = false; // 结束加载
							console.error("请求失败：", error);
							alert("请求失败：" + error);
						});

				} else {
					alert('类型错误');
				}
			},
			toLogin() { //去登录
				this.$router.push({
					path: '/DevelopersLogin',
					query: {}
				});
			},
			toDeveloperAgreement(event) { //确开发者协议
				event.stopPropagation();
				let page = this.$router.resolve({
					path: '/DeveloperAgreement',
					query: {}
				});
				window.open(page.href, '_blank');
			},
			//...
		},
	};
</script>

<style>
	input[type="number"]::-webkit-inner-spin-button,
	input[type="number"]::-webkit-outer-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	input[type="number"] {
		-moz-appearance: textfield;
	}

	#particles-js {
		width: 100%;
		height: calc(100% - 100px);
		position: absolute;
	}

	.login-container {
		display: flex;
		justify-content: center;
		align-items: center;
		height: 100vh;
		background-color: #f2f2f2;
	}

	.login-box {
		background-color: #fff;
		padding: 20px;
		border-radius: 8px;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
	}
</style>